module.exports = __webpack_public_path__ + "img/icon-file-upload.589d81c7.svg";